/*
 * @Descripttion: 关怀短信具体任务的详细发送记录
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import { Form, Input, DatePicker, Button, Table } from '@alifd/next';
import LzPagination from '@/components/common/LzPagination';
import { Servlets } from '@/service';
import moment from 'moment';
import utils from '@/common/utils';
import LzMsg from '@/components/common/LzMsg';

const BASEFORMDATA = {
  id: '',
  orderNo: '',
  startTime: '',
  endTime: '',
};

const OrderCareTaskSendListDetail = ({ startTime = '', endTime = '', id = ''}) => {
  const [formSelect, setFormSelect] = useState({
    ...BASEFORMDATA,
    id,
    startTime,
    endTime,
    orderNo: ''
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [pageInfo, setPageInfo] = useState({ pageNo: 1, pageSize: 10, total: 0 }); // 分页数据
  const [tableData, setTableData] = useState([]);
  const searchData = async (v) => {
    // await 接口
    setTableLoading(true);
    const params = {
      id,
      startTime: formSelect.startTime ? moment(`${formSelect.startTime} 00:00:00`).valueOf() : '',
      endTime: formSelect.endTime ? moment(`${formSelect.endTime} 23:59:59`).valueOf() : '',
      orderNo: formSelect.orderNo,
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      ...v,
    };
    Servlets('getOrderCareDetailData', params).then((res) => {
      if(res.success) {
        setTableData(res.data);
        setPageInfo({
          ...pageInfo,
          pageNo: res.page?.pageNo || pageInfo.pageNo,
          pageSize: res.page?.pageSize || pageInfo.pageSize,
          total: res.page.total,
        });
        setTableLoading(false);
      } else {
        LzMsg.error(res.resp_msg);
      }
    }).catch((e) => {
      console.log(e);
      setTableLoading(false);
    });
  };

  const handlePageSizeChange = async (pages: object = {}) => {
    try {
      await searchData({ pageNo: pages.pageNo, pageSize: pages.pageSize });
    } catch (e) {
      // LzMsg.error(e.message);
      console.log(e)
    }
  };  // 选择时间
  const changeActivityTime = (val) => {
    let startT;
    let endT;
    startT = val[0] ? moment(val[0]).format('YYYY-MM-DD') : '';
    endT = val[1] ? moment(val[1]).format('YYYY-MM-DD') : '';
    // startT = val[0] ? new Date(val[0]).getTime() : '';
    // endT = val[1] ? new Date(val[1]).getTime() : '';
    setFormSelect({ ...formSelect, startTime: startT, endTime: endT, time: val });
  };

  const resetForm = () => {
    setFormSelect({ ...BASEFORMDATA, id });
    searchData({...BASEFORMDATA, id});
  };

  /**
   * 导出exl
   */
  const exportExl = () => {
    if (tableData.length) {
      Servlets('exportOrderCareDetailData', {
        id,
        functionType: 2,
        startTime: formSelect.startTime,
        endTime: formSelect.endTime,
        orderNo: formSelect.orderNo,
      }).then((res) => {
        utils.downloadFile(res);
      })
    } else {
      LzMsg.error('数据为空，请切换查询条件后重试');
    }
  };

  useEffect(() => {
    searchData();
  }, []);

  return <div>
    <Form inline>
      <Form.Item label="订单号">
        <Input placeholder="请输入订单号" value={formSelect.orderNo} onChange={(value) => setFormSelect({ ...formSelect, orderNo: value })} size="medium" />
        <div style={{marginTop: 10, color: 'red'}}>输入多个订单号时，请用英文逗号","分隔</div>
      </Form.Item>
      <Form.Item label="发送时间">
        <DatePicker.RangePicker
          placeholder={['开始时间', '结束时间']}
          popupAlign="tr tr"
          popupContainer={(target) => target.parentNode}
          value={[formSelect.startTime, formSelect.endTime]}
          onChange={changeActivityTime} />
      </Form.Item>
      <Form.Item label=" ">
        <Button type="primary" style={{marginRight: 10}} onClick={() => searchData()}>查询</Button>
        <Button style={{marginRight: 10}} onClick={resetForm}>重置</Button>
        <Button type="secondary" onClick={exportExl}>导出记录</Button>
      </Form.Item>
    </Form>
    <div style={{minHeight: 220}}>
      <Table dataSource={tableData} loading={tableLoading}>
        <Table.Column title="订单号" dataIndex="orderNo" />
        <Table.Column title="发送时间" dataIndex="sendTime" key="sendTime" cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')} />
      </Table>
    </div>
    <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
  </div>
};

export default OrderCareTaskSendListDetail;
